import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { LocalStorageService } from "src/core/services/local-storage.service";
import { LogService } from "src/core/services/log.service";
import { Log } from "src/interfaces/log";

@Injectable({
    providedIn: 'root'
})
export class LogsResolver implements Resolve<any> {
    limit: number = 10;
    page: number = 1;
    constructor(
        private _logService: LogService,
        private localStorageService: LocalStorageService
    ) {
        const limit = this.localStorageService.get('LOGS', 'LIMIT');
        if (limit) {
            this.limit = parseInt(limit);
        }
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<
    {
        logs: Log[],
        pageNumber: number
    }
    > {

        const page = this.localStorageService.get('LOGS', 'PAGE');
        if (page) {
            this.page = parseInt(page);
        } else {
            this.page = 1;
        }
        
        const logs = await  this
            ._logService
            .getLogs(this.page, this.limit);
        return {
            logs,
            pageNumber: this.page
        }
    }
}